import React from 'react';
import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>מדיניות פרטיות – HOMA</h1>
        
        <p className={styles.intro}>
          ב-HOMA אנו מכבדים את פרטיות הגולשים באתר ופועלים לשמירה על המידע הנמסר לנו.
          להלן עיקרי מדיניות הפרטיות שלנו:
        </p>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>1. איסוף מידע</h2>
          <p className={styles.sectionContent}>
            בעת השארת פרטים בטופס באתר (שם, טלפון, אימייל) אנו אוספים את המידע שהוזן בטופס בלבד.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>2. שימוש במידע</h2>
          <p className={styles.sectionContent}>
            הפרטים שתמסרו ישמשו אך ורק לצורך שליחת הצעת מחיר חד-פעמית למייל שציינתם.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>3. שמירת המידע</h2>
          <p className={styles.sectionContent}>
            המידע אינו נשמר במאגר נתונים קבוע ואינו מועבר לצדדים שלישיים.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>4. אבטחת מידע</h2>
          <p className={styles.sectionContent}>
            אנו נוקטים באמצעים סבירים להגן על המידע בעת שליחתו, אך אין באפשרותנו להבטיח אבטחה מוחלטת של המידע ברשת האינטרנט.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>5. יצירת קשר</h2>
          <p className={styles.sectionContent}>
            לכל שאלה או בקשה בעניין פרטיות המידע, ניתן לפנות אלינו בכתובת:
          </p>
          <div className={styles.contactInfo}>
            <p>📧 homaisraelwebsite@gmail.com</p>
            <p>📞 052-8643336</p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>6. אחסון מקומי</h2>
          <p className={styles.sectionContent}>
            אנו משתמשים באחסון מקומי בדפדפן (localStorage ו־sessionStorage) כדי לשפר את חוויית השימוש באתר, לדוגמה:
          </p>
          <ul className={styles.sectionList}>
            <li>שמירת פריטים בעגלת הקניות</li>
            <li>שמירת העדפות פילטרים</li>
          </ul>
          <p className={styles.sectionContent}>
            מידע זה נשמר אך ורק במכשיר שלך ואינו מועבר או נשמר בשרתים שלנו.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>7. עדכונים</h2>
          <p className={styles.sectionContent}>
            מדיניות זו עשויה להתעדכן מעת לעת, והגרסה המעודכנת תפורסם בעמוד זה.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
